module.exports = __webpack_public_path__ + "static/media/blash.964cfea4.svg";